module.exports = __webpack_public_path__ + "img/service-small.4b504901.webp";